import { FC } from 'react';
import { Search } from '@deere/fuel-react/Search';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles'


interface SupplierSelectComponentProps {
    userType: string;
    supplierList: { label: string; value: string }[];
    supplierChangeHandler: (value: any) => void;
    handleKeyDown?: (event: any) => void;
}

const StyledPopper = styled(Popper)({
    '& .MuiAutocomplete-paper': {
        maxHeight: 200,
        overflowY: 'auto',
        overflowX: 'auto',
        whiteSpace: 'nowrap'
    },
});


const SupplierSelectComponent: FC<SupplierSelectComponentProps> = ({
    userType,
    supplierList,
    supplierChangeHandler,
    handleKeyDown
}) => {
    return (
<Search
    label="Search by supplier"
    options={supplierList}
    placeholder="Search by name, category, or keyword"
    variant="onWhite"
    slotProps={{
        search: {
            onInputChange: (_event: any, value: any) => {
                supplierChangeHandler(value);
            },
            onKeyDown: handleKeyDown,
            PopperComponent: StyledPopper
        }
    }}
/>

    );
};

export default SupplierSelectComponent;
